const divStyles = "bg-legacy-light-grey h-px";

export const DividerWithTip = ({ className }: { className?: string }) => {
  return (
    <div className={`mx-auto flex relative w-full divider-tip ${className ?? ""}`}>
      <div className={`${divStyles} w-1/2 mr-9 md:mr-14`}></div>
      <div
        className={`absolute border-b border-r border-legacy-light-grey h-[25px] w-[25px] md:h-10 md:w-10 left-1/2 
            -translate-x-1/2 -top-[12px] md:-top-[19px] rotate-45 z-10`}
      ></div>
      <div className={`${divStyles} w-1/2`}></div>
    </div>
  );
};
